module.exports = __webpack_public_path__ + "img/wind-resilience.034c6689.png";